<template>
  <v-container fluid>
    <SidebarNavigation />

    <v-card>
      <v-tabs v-model="tab">
        <v-tabs-slider color="primary"></v-tabs-slider>

        <v-tab v-for="item in tabItems" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
    </v-card>

    <v-card>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row class="pt-1 pl-1 d-flex align-center">
            <!-- Tanggal Awal & Akhir -->
            <v-col cols="auto mt-5">
              <v-menu
                v-model="pagination.startMenu"
                :close-on-content-click="false"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    readonly
                    v-model="pagination.startDate"
                    label="Tanggal Awal"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="pagination.startDate"
                  @input="onDateChange('start')"
                  locale="id"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="auto mt-5">
              <v-menu
                v-model="pagination.endMenu"
                :close-on-content-click="false"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="pagination.endDate"
                    label="Tanggal Akhir"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="pagination.endDate"
                  @input="onDateChange"
                  locale="id"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <!-- Tombol Aksi -->
            <v-col cols="auto">
              <v-btn class="primary" @click="openDialog()">Tambah</v-btn>
            </v-col>
            <v-col cols="auto" v-if="user.mst_division_id == 5">
              <v-btn class="primary" @click="downloadTemplateExcel()"
                >Template</v-btn
              >
            </v-col>
            <v-col cols="auto" v-if="user.mst_division_id == 5">
              <v-btn class="primary" @click="openDialogUploadExcel()"
                >Upload</v-btn
              >
            </v-col>

            <!-- Spacer untuk mendorong search ke kanan -->
            <v-spacer></v-spacer>

            <!-- Search -->
            <v-col cols="auto mr-1">
              <v-text-field
                v-model="pagination.search"
                label="Search"
                append-icon="mdi-magnify"
                dense
                hide-details
                class="search-input"
                style="max-width: 250px"
                outlined
                @input="debouncedSearch"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-data-table
                mobile-breakpoint="0"
                fixed-header
                dense
                class="elevation-5"
                :headers="tableHeaders"
                :items="suggestionsList"
                :items-per-page.sync="pagination.itemsPerPage"
                :page.sync="pagination.page"
                :sort-by="pagination.sortBy"
                :sort-desc="pagination.sortDesc"
                :loading="isLoading"
                :server-items-length="totalSuggestions"
                item-key="id"
                @update:page="updateQuery('page', $event)"
                @update:items-per-page="updateQuery('itemsPerPage', $event)"
                @update:sort-by="updateQuery('sortBy', $event)"
                @update:sort-desc="updateQuery('sortDesc', $event)"
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td>
                        <span
                          color="transparent"
                          class="text-none"
                          @click="openDialogSuggestionDetail(item)"
                        >
                          {{ item.title }}
                        </span>
                      </td>
                      <td>{{ item.suggestion_category_name }}</td>
                      <td>
                        <span @click="openDialogPic(item)">{{
                          item.step_name ? `${item.step_name}` : ""
                        }}</span>
                      </td>
                      <td>{{ item.last_status }}</td>
                      <td>
                        <v-tooltip
                          bottom
                          v-if="item.action_history_approval === 't'"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              icon
                              @click="openDialogApproval(item.id)"
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          Tampilkan
                        </v-tooltip>
                      </td>
                      <td>
                        <div v-if="item.file_names">
                          <v-icon
                            v-for="(fileName, index) in fileList(
                              item.file_names
                            )"
                            :key="`icon-${index}`"
                            color="primary"
                            @click="downloadAttachment(item.id, fileName)"
                          >
                            {{ getFileIcon(fileName) }}
                          </v-icon>
                        </div>
                      </td>
                      <td>
                        <v-tooltip
                          v-if="
                            item.last_status ===
                            'Approved Operation Excellence & Improvement'
                          "
                          bottom
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              icon
                              @click="openDialogUploadImplement(item.id)"
                            >
                              <v-icon color="primary">mdi-upload</v-icon>
                            </v-btn>
                          </template>
                          Upload Bukti Implementasi
                        </v-tooltip>

                        <div v-else-if="item.file_names_bukti">
                          <v-icon
                            v-for="(fileName, index) in fileList(
                              item.file_names_bukti
                            )"
                            :key="`icon-${index}`"
                            color="primary"
                            @click="downloadBukti(item.id, fileName)"
                          >
                            {{ getFileIcon(fileName) }}
                          </v-icon>
                        </div>
                      </td>

                      <td>
                        <div v-if="item.file_names_materi">
                          <v-icon
                            v-for="(fileName, index) in fileList(
                              item.file_names_materi
                            )"
                            :key="`icon-${index}`"
                            color="primary"
                            @click="downloadMateri(item.id, fileName)"
                          >
                            {{ getFileIcon(fileName) }}
                          </v-icon>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                x-small
                                v-bind="attrs"
                                v-on="on"
                                icon
                                @click="openDialogUploadMateriUpdate(item.id)"
                              >
                                <v-icon color="primary">mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            Edit
                          </v-tooltip>
                        </div>

                        <div v-else-if="item.last_status == 'Implemented'">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                @click="openDialogUploadMateri(item.id)"
                              >
                                <v-icon color="primary">mdi-upload</v-icon>
                              </v-btn>
                            </template>
                            Upload Materi Presentasi
                          </v-tooltip>
                        </div>
                      </td>

                      <td>
                        <div class="small-font">
                          {{ item.created_by_name }}
                        </div>
                        <div class="small-font">
                          {{ item.created_on }}
                        </div>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-if="
                                item.last_status == 'waiting approval' ||
                                item.last_status == 'need to analysis'
                              "
                              color="primary"
                              icon
                              @click="openDialogUpdate(item)"
                              v-bind="attrs"
                              v-on="on"
                              x-small
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          Ubah
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item> </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- create -->
    <v-dialog v-model="isDialogOpen" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValid">
            <v-autocomplete
              :items="suggestionCategoryOptions"
              item-text="name"
              item-value="id"
              label="Kategori"
              dense
              outlined
              v-model="selectedSuggestionCategoryId"
              :rules="[(v) => !!v || 'Pilih kategory terlebih dahulu !']"
            >
              <template v-slot:item="data">
                <div class="d-flex flex-column">
                  <span class="font-weight-medium text-body-2">{{
                    data.item.name
                  }}</span>
                  <span class="text-caption text--secondary">{{
                    data.item.description
                  }}</span>
                </div>
              </template></v-autocomplete
            >
            <v-text-field
              v-model="suggestionFormData.title"
              label="Judul"
              required
              :rules="[(v) => !!v || 'Judul tidak boleh kosong !']"
            ></v-text-field>
            <v-textarea
              v-model="suggestionFormData.description"
              label="Latar belakang / Uraian masalah"
              require
              :rules="[(v) => !!v || 'Latar belakang tidak boleh kosong !']"
            ></v-textarea>
            <v-textarea
              v-model="suggestionFormData.suggestions"
              label="Solusi"
              type="suggestions"
              :rules="[(v) => !!v || 'Solusi tidak boleh kosong !']"
              required
            ></v-textarea>
            <v-text-field
              v-model="formattedBenefit"
              label="Potensi Benefit"
              type="text"
              :rules="[
                (v) => !!v || 'Benefit tidak boleh kosong',
                (v) =>
                  parseInt(v.replace(/\./g, '')) >= 0 ||
                  'Benefit harus minimal 0',
              ]"
            ></v-text-field>

            <v-textarea
              v-model="suggestionFormData.noted"
              label="Keterangan Biaya"
            ></v-textarea>
            <v-file-input
              v-model="suggestionFormData.files"
              label="Lampiran Perhitungan (optional)"
              :accept="'.doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.mp4,.avi,.mkv'"
              :rules="[(v) => !!v || 'File tidak boleh kosong']"
              outlined
              dense
              multiple
              hint="Anda dapat memilih lebih dari satu file dengan menekan Ctrl (Windows) atau Command (Mac) saat memilih file. Total ukuran file yang dipilih tidak boleh melebihi 10 MB."
              persistent-hint
            ></v-file-input>

            <ul>
              <li
                v-for="(file, index) in suggestionFormData.files"
                :key="index"
              >
                {{ file.name }}
              </li>
            </ul>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpen = false">Cancel</v-btn>
          <v-btn color="primary" :disabled="!isFormValid" @click="submit"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- update -->
    <v-dialog v-model="isDialogOpenUpdate" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValidUpdate">
            <v-autocomplete
              :items="suggestionCategoryOptions"
              item-text="name"
              item-value="id"
              label="Kategori"
              dense
              outlined
              v-model="selectedSuggestionCategoryId"
              :rules="[(v) => !!v || 'Pilih kategory terlebih dahulu !']"
              ><template v-slot:item="data">
                <div class="d-flex flex-column">
                  <span class="font-weight-medium text-body-2">{{
                    data.item.name
                  }}</span>
                  <span class="text-caption text--secondary">{{
                    data.item.description
                  }}</span>
                </div>
              </template></v-autocomplete
            >
            <v-text-field
              v-model="suggestionFormDataUpdate.title"
              label="Judul"
              required
              :rules="[(v) => !!v || 'Judul tidak boleh kosong !']"
            ></v-text-field>
            <v-textarea
              v-model="suggestionFormDataUpdate.description"
              label="Latar belakang / Uraian masalah"
              require
              :rules="[(v) => !!v || 'Latar belakang tidak boleh kosong !']"
            ></v-textarea>
            <v-textarea
              v-model="suggestionFormDataUpdate.suggestions"
              label="Solusi"
              type="suggestions"
              :rules="[(v) => !!v || 'Solusi tidak boleh kosong !']"
              required
            ></v-textarea>
            <v-text-field
              v-model="formattedBenefitUpdate"
              label="Potensi Benefit"
              type="text"
              :rules="[
                (v) => !!v || 'Benefit tidak boleh kosong',
                (v) => /^\d+(\.\d+)*$/.test(v) || 'Hanya boleh angka',
                (v) =>
                  parseInt(v.replace(/\./g, '')) >= 0 ||
                  'Benefit harus minimal 0',
              ]"
            >
            </v-text-field>

            <v-textarea
              v-model="suggestionFormDataUpdate.noted"
              label="Keterangan Biaya"
            ></v-textarea>
            <v-file-input
              v-model="suggestionFormDataUpdate.files"
              label="Lampiran Perhitungan (optional)"
              :accept="'.doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.mp4,.avi,.mkv'"
              :rules="[(v) => !!v || 'File tidak boleh kosong']"
              outlined
              dense
              multiple
              hint="Anda dapat memilih lebih dari satu file dengan menekan Ctrl (Windows) atau Command (Mac) saat memilih file. Total ukuran file yang dipilih tidak boleh melebihi 10 MB."
              persistent-hint
            ></v-file-input>
            <ul>
              <li
                v-for="(file, index) in suggestionFormDataUpdate.files"
                :key="index"
              >
                {{ file.name }}
              </li>
            </ul>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenUpdate = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="!isFormValidUpdate"
            @click="submitUpdate"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- delete -->
    <v-dialog v-model="isDialogOpenDelete" max-width="400px">
      <v-card>
        <v-card-title class="headline">Konfirmasi Hapus</v-card-title>
        <v-card-text>
          Yakin ingin menghapus {{ selectedSuggestion.title }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" @click="submitDelete">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Riwayat Persetujuan -->
    <v-dialog v-model="isDialogOpenApproval" max-width="700px">
      <v-card>
        <v-card-title class="headline">Riwayat Persetujuan</v-card-title>
        <v-data-table
          mobile-breakpoint="0"
          :headers="tableHeadersApproval"
          :items="approvalList"
          class="elevation-1"
        >
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- upload implement -->
    <v-dialog v-model="isDialogOpenUploadImplement" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValidUploadImplement">
            <v-row>
              <v-col class="text-right">
                <a href="" @click="downloadTemplateImplementasi($event)">
                  Download Template Implementasi
                </a>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      @click="downloadTemplateImplementasi($event)"
                    >
                      <v-icon color="primary">mdi mdi-microsoft-excel</v-icon>
                    </v-btn>
                  </template>
                  Download Template Implementasi
                </v-tooltip>
              </v-col>
            </v-row>
            <v-file-input
              v-model="implementUploadFormData.files"
              label="Upload Bukti Implementasi"
              :accept="'.xls,.xlsx'"
              :rules="[(v) => !!v || 'File tidak boleh kosong']"
              outlined
              dense
              hint="Total ukuran file yang dipilih tidak boleh melebihi 10 MB."
              persistent-hint
            ></v-file-input>
            <ul>
              <li
                v-for="(file, index) in implementUploadFormData.files"
                :key="index"
              >
                {{ file.name }}
              </li>
            </ul>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenUploadImplement = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="!isFormValidUploadImplement"
            @click="submitUploadImplement"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- suggestion detail -->
    <v-dialog v-model="isDialogOpenSuggestionDetail" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            readonly
            :items="suggestionCategoryOptions"
            item-text="name"
            item-value="id"
            label="Kategori"
            dense
            outlined
            v-model="selectedSuggestionCategoryId"
          ></v-autocomplete>
          <v-text-field
            readonly
            v-model="suggestionDetail.title"
            label="Judul"
            required
          ></v-text-field>
          <v-textarea
            v-model="suggestionDetail.description"
            label="Latar belakang / Uraian masalah"
            require
            readonly
          ></v-textarea>
          <v-textarea
            v-model="suggestionDetail.suggestions"
            label="Solusi"
            type="suggestions"
            readonly
          ></v-textarea>
          <v-text-field
            v-model="formattedBenefitDetail"
            label="Potensi Benefit"
            type="text"
            readonly
          >
          </v-text-field>

          <v-textarea
            v-model="suggestionDetail.noted"
            label="Keterangan Biaya"
            readonly
          ></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenSuggestionDetail = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- List Pic -->
    <v-dialog v-model="isDialogOpenPic" max-width="500px">
      <v-card>
        <v-card-title class="headline">Approver</v-card-title>
        <v-data-table
          mobile-breakpoint="0"
          :headers="tableHeadersPic"
          :items="listPic"
          class="elevation-1"
        >
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- upload materi -->
    <v-dialog v-model="isDialogOpenUploadMateri" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValidUploadMateri">
            <v-row>
              <v-col class="text-right">
                <a href="" @click="downloadTemplateMateri($event)">
                  Download Template Materi Presentasi
                </a>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      @click="downloadTemplateMateri($event)"
                    >
                      <v-icon color="primary"
                        >mdi mdi-microsoft-powerpoint</v-icon
                      >
                    </v-btn>
                  </template>
                  Download Template Materi Presentasi
                </v-tooltip>
              </v-col>
            </v-row>
            <v-file-input
              v-model="materiUploadFormData.files"
              label="Klik disini untuk upload."
              :accept="'.pptx'"
              :rules="[(v) => !!v || 'File tidak boleh kosong']"
              outlined
              dense
              hint="Total ukuran file yang dipilih tidak boleh melebihi 10 MB."
              persistent-hint
            ></v-file-input>
            <ul>
              <li
                v-for="(file, index) in materiUploadFormData.files"
                :key="index"
              >
                {{ file.name }}
              </li>
            </ul>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenUploadMateri = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="!isFormValidUploadMateri"
            @click="submitUploadMateri"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- upload excel -->
    <v-dialog v-model="isDialogOpenUploadExcel" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Upload</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValidUploadExcel">
            <v-file-input
              v-model="excelUploadFormData.file"
              label="Klik disini untuk mengunggah"
              :accept="'.xls,.xlsx'"
              :rules="[(v) => !!v || 'File tidak boleh kosong']"
            />

            <ul></ul>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenUploadExcel = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="!isFormValidUploadExcel"
            @click="submitUploadExcel"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";
import { getLast30Days } from "@/utils/date";
// import { formatNumberRibuan } from "@/utils/format";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      awsObjectUrl: process.env.VUE_APP_AWS_OBJECT_URL,
      awsPath: process.env.VUE_APP_AWS_PATH,
      selectedSuggestion: {},
      tab: 1,
      tabItems: ["Suggestion"],
      tableHeaders: [
        { text: "Judul", align: "center", value: "title" },
        { text: "Kategori", align: "center", value: "category" },
        { text: "PIC Persetujuan", align: "center", value: "step_name" },
        { text: "Status Terakhir", align: "center", value: "last_status" },
        {
          text: "Riwayat Persetujuan",

          align: "center",
          value: "history_approval",
        },
        {
          text: "Lampiran Perhitungan",

          align: "center",
          value: "lampiran_perhitungan",
        },
        {
          text: "Bukti Implementasi",

          align: "center",
          value: "bukti",
        },
        {
          text: "Materi Presentasi",

          align: "center",
          value: "materi",
        },
        { text: "Dibuat Oleh", align: "center", value: "id" },
        { text: "Aksi", align: "center", value: "actions", sortable: false },
      ],
      tableHeadersApproval: [
        { text: "Name", align: "center", value: "step_name" },
        { text: "Status", align: "center", value: "status" },
        { text: "Catatan", align: "center", value: "comments" },
        { text: "Di Setujui Oleh", align: "center", value: "created_by_name" },
        { text: "Tanggal", align: "center", value: "created_on" },
      ],
      tableHeadersPic: [
        { text: "Nama", align: "center", value: "mst_employee_name" },
        { text: "Email", align: "center", value: "mst_employee_email" },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: false,
        startMenu: false,
        endMenu: false,
        startDate: getLast30Days().start,
        endDate: getLast30Days().end,
        search: "",
      },
      totalSuggestions: 0,
      suggestionsList: [],
      approvalList: [],
      listPic: [],
      isLoading: false,
      dialogTitle: "Tambah Suggestion",
      isFormValid: false,
      isFormValidUpdate: false,
      isFormValidUploadImplement: false,
      isFormValidUploadMateri: false,
      isFormValidUploadExcel: false,
      suggestionCategoryOptions: null,
      suggestionDetail: {
        id: null,
        suggestion_category_id: null,
        title: "",
        description: "",
        suggestions: "",
        benefit: 0,
        noted: "",
      },
      suggestionFormData: {
        suggestion_category_id: null,
        title: "",
        description: "",
        suggestions: "",
        benefit: 0,
        noted: "",
        files: [],
      },
      suggestionFormDataUpdate: {
        id: null,
        suggestion_category_id: null,
        title: "",
        description: "",
        suggestions: "",
        benefit: 0,
        noted: "",
        files: [],
      },
      implementUploadFormData: {
        files: null,
      },
      materiUploadFormData: {
        files: null,
      },
      excelUploadFormData: {
        file: null,
      },
      isDialogOpen: false,
      isDialogOpenUpdate: false,
      isDialogOpenDelete: false,
      isDialogOpenApproval: false,
      isDialogOpenPic: false,
      isDialogOpenSuggestionDetail: false,
      isDialogOpenUploadImplement: false,
      isDialogOpenUploadMateri: false,
      isDialogOpenUploadExcel: false,
      selectedSuggestionCategoryId: null,
    };
  },
  methods: {
    async fetchSuggestionCategory() {
      api
        .get(`/suggestions-categories`)
        .then(({ data }) => {
          this.suggestionCategoryOptions = data.data.data;
          // console.log(this.suggestionCategoryOptions);
        })
        .catch((error) => {
          console.error("Error fetching position:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async fetchSuggestion() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "id",
        sortDesc: query.sortDesc || this.pagination.sortDesc || true,
        startDate: query.startDate || this.pagination.startDate,
        endDate: query.endDate || this.pagination.endDate,
      };

      await api
        .get("/suggestions", { params })
        .then(({ data }) => {
          // console.log(data);
          this.suggestionsList = data.data.data;
          this.totalSuggestions = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    openDialogSuggestionDetail(params = null) {
      this.selectedSuggestionCategoryId = params.suggestion_category_id;
      this.dialogTitle = "Detail Suggestion";
      this.suggestionDetail = { ...params };
      this.isDialogOpenSuggestionDetail = true;
    },
    openDialog() {
      this.dialogTitle = "Tambah Suggestion";
      this.isDialogOpen = true;
    },
    openDialogUpdate(params = null) {
      this.selectedSuggestionCategoryId = params.suggestion_category_id;
      this.dialogTitle = "Ubah Suggestion";
      this.suggestionFormDataUpdate = { ...params };
      this.suggestionFormDataUpdate.files = [];
      // console.log(this.suggestionFormDataUpdate);
      this.isDialogOpenUpdate = true;
      this.isSuggestionCategoryLoading = false;
    },
    openDialogApproval(id) {
      api
        .get(`/approvals/by-suggestion-id/${id}`)
        .then(({ data }) => {
          this.approvalList = data.data;
          this.isDialogOpenApproval = true;
        })
        .catch((error) => {
          this.isDialogOpenApproval = true;
          this.approvalList = [];
          console.error("Error fetching position:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    openDialogPic(params) {
      // console.log(params);
      this.listPic = params.list_pic;
      console.log(this.listPic.list_pic);
      this.isDialogOpenPic = true;
      this.isLoading = false;
      store.dispatch("hideLoading");
    },
    openDialogUploadImplement(suggestionId) {
      this.dialogTitle = "Implementasi";
      this.implementUploadFormData = {
        suggestion_id: suggestionId,
        files: null,
      };
      this.isDialogOpenUploadImplement = true;
    },
    openDialogUploadMateri(suggestionId) {
      this.dialogTitle = "Upload Materi Presentasi";
      this.materiUploadFormData = {
        suggestion_id: suggestionId,
        files: null,
      };
      this.isDialogOpenUploadMateri = true;
    },
    openDialogUploadMateriUpdate(suggestionId) {
      this.dialogTitle = "Ubah Materi Presentasi";
      this.materiUploadFormData = {
        suggestion_id: suggestionId,
        files: null,
      };
      this.isDialogOpenUploadMateri = true;
    },
    openDialogUploadExcel() {
      this.isDialogOpenUploadExcel = true;
    },
    openDialogDelete(suggestion) {
      this.selectedSuggestion = suggestion; // Menyimpan suggestion yang dipilih
      this.isDialogOpen = true; // Menampilkan dialog konfirmasi
    },
    downloadAttachment(id, fileName) {
      // console.log(pathName);
      window.open(
        `${this.awsObjectUrl}${this.awsPath}document/calculation/${id}/${fileName}`,
        "_blank"
      );
    },
    downloadTemplateExcel() {
      // console.log(pathName);
      window.open(
        `${this.awsObjectUrl}${this.awsPath}document/template/template_upload_suggestion.xlsx`,
        "_blank"
      );
    },
    downloadTemplateMateri(event) {
      // console.log(pathName);
      event.preventDefault();
      window.open(
        `${this.awsObjectUrl}${this.awsPath}document/template/template_materi_presentasi.pptx`,
        "_blank"
      );
    },
    downloadTemplateImplementasi(event) {
      // console.log(pathName);
      event.preventDefault();
      window.open(
        `${this.awsObjectUrl}${this.awsPath}document/template/form_verifikasi_&_implementasi.xlsx`,
        "_blank"
      );
    },
    downloadMateri(id, fileName) {
      // console.log(pathName);
      window.open(
        `${this.awsObjectUrl}${this.awsPath}document/materi/${id}/${fileName}`,
        "_blank"
      );
    },
    downloadBukti(id, fileName) {
      // console.log(pathName);
      window.open(
        `${this.awsObjectUrl}${this.awsPath}document/implemented/${id}/${fileName}`,
        "_blank"
      );
    },
    fileList(fileNames) {
      return fileNames ? fileNames.split("|") : [];
    },
    getFileIcon(fileName) {
      const extension = fileName.split(".").pop().toLowerCase();
      const icons = {
        xlsx: "mdi-file-excel-outline",
        jpeg: "mdi-image",
        png: "mdi-image",
        jpg: "mdi-image",
        pdf: "mdi-file-pdf-box",
        mp4: "mdi-video-box",
      };
      return icons[extension] || "mdi-file-download-outline";
    },
    async submit() {
      store.dispatch("showLoading");

      const formData = new FormData();
      formData.append("title", this.suggestionFormData.title);
      formData.append("description", this.suggestionFormData.description);
      formData.append("benefit", this.suggestionFormData.benefit);
      formData.append("noted", this.suggestionFormData.noted);
      formData.append(
        "suggestion_category_id",
        this.selectedSuggestionCategoryId
      );
      formData.append("suggestions", this.suggestionFormData.suggestions);
      this.suggestionFormData.files.forEach((file) => {
        formData.append("files", file);
      });

      // formData.forEach((value, key) => {
      //   console.log(key, value);
      // });

      api
        .post("/suggestions", formData)
        .then((response) => {
          const message = response.data.message;
          // this.fetchSuggestion();
          this.suggestionFormData = {
            id: null,
            title: "",
            description: "",
            benefit: 0,
            noted: "",
            files: [],
          };
          this.isDialogOpen = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
          this.fetchSuggestion();
        })
        .catch((error) => {
          let message = "Failed to save suggestion!";

          // console.log(error.response.data);

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", { message, isSuccess: false });
          this.isDialogOpen = false;
          this.fetchSuggestion();
          store.dispatch("hideLoading");
        })
        .finally(() => {
          this.fetchSuggestion();
        });
    },
    async submitUpdate() {
      store.dispatch("showLoading");

      const formData = new FormData();
      formData.append("title", this.suggestionFormDataUpdate.title);
      formData.append("description", this.suggestionFormDataUpdate.description);
      formData.append("benefit", this.suggestionFormDataUpdate.benefit);
      formData.append("noted", this.suggestionFormDataUpdate.noted);
      formData.append(
        "suggestion_category_id",
        this.selectedSuggestionCategoryId
      );
      formData.append("suggestions", this.suggestionFormDataUpdate.suggestions);
      formData.append("id", this.suggestionFormDataUpdate.id);
      this.suggestionFormDataUpdate.files.forEach((file) => {
        formData.append("files", file);
      });

      // formData.forEach((value, key) => {
      //   console.log(key, value);
      // });

      api
        .post("/suggestions/update", formData)
        .then((response) => {
          const message = response.data.message;
          this.fetchSuggestion();
          this.isDialogOpenUpdate = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to update suggestion!";

          // console.log(error.response.data);

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", { message, isSuccess: false });
        })
        .finally(() => {
          this.isLoading = false;
          this.fetchSuggestion();

          store.dispatch("hideLoading");
        });
    },
    async submitUploadImplement() {
      store.dispatch("showLoading");

      if (!this.implementUploadFormData.files) {
        store.dispatch("triggerSnackbar", {
          message: "File tidak boleh kosong !",
          isSuccess: false,
        });
        store.dispatch("hideLoading");
        return;
      }

      const formData = new FormData();

      formData.append(
        "suggestion_id",
        this.implementUploadFormData.suggestion_id
      );

      // this.implementUploadFormData.files.forEach((file) => {
      formData.append("files", this.implementUploadFormData.files);
      // });

      // formData.forEach((value, key) => {
      //   console.log(key, value);
      // });

      api
        .post("/suggestions/upload-implemented", formData)
        .then((response) => {
          const message = response.data.message;
          this.fetchSuggestion();
          this.isDialogOpenUploadImplement = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save upload implements!";

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", { message, isSuccess: false });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async submitUploadMateri() {
      store.dispatch("showLoading");

      if (!this.materiUploadFormData.files) {
        store.dispatch("triggerSnackbar", {
          message: "File tidak boleh kosong !",
          isSuccess: false,
        });
        store.dispatch("hideLoading");
        return;
      }

      const formData = new FormData();

      formData.append("suggestion_id", this.materiUploadFormData.suggestion_id);
      formData.append("files", this.materiUploadFormData.files);

      // formData.forEach((value, key) => {
      //   console.log(key, value);
      // });

      api
        .post("/suggestions/upload-materi", formData)
        .then((response) => {
          const message = response.data.message;
          this.fetchSuggestion();
          this.isDialogOpenUploadMateri = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save upload materis!";

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", { message, isSuccess: false });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async submitUploadExcel() {
      store.dispatch("showLoading");

      if (!this.excelUploadFormData.file) {
        store.dispatch("triggerSnackbar", {
          message: "File tidak boleh kosong !",
          isSuccess: false,
        });
        store.dispatch("hideLoading");
        return;
      }

      const formData = new FormData();

      // console.log(this.excelUploadFormData.file);

      formData.append("file", this.excelUploadFormData.file);

      // formData.forEach((value, key) => {
      //   console.log(key, value);
      // });

      api
        .post("/suggestions/upload-excel", formData)
        .then((response) => {
          const message = response.data.message;
          this.fetchSuggestion();
          this.isDialogOpenUploadExcel = false;
          this.excelUploadFormData.file = null;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save upload excel!";
          this.excelUploadFormData.file = null;

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", { message, isSuccess: false });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async submitDelete() {
      store.dispatch("showLoading");

      const suggestion = this.selectedSuggestion;

      // Menggunakan POST untuk penghapusan
      api
        .post("/suggestions/delete", { id: suggestion.id }) // Kirimkan ID employee ke backend
        .then((response) => {
          const message =
            response.data.message || "Employee deleted successfully!"; // Pesan sukses

          // Memperbarui data dan menampilkan snackbar dengan pesan sukses
          this.fetchSuggestion();
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: true,
          });

          // Menutup dialog setelah penghapusan berhasil
          this.isDialogOpen = false;
        })
        .catch((error) => {
          console.error("Error deleting suggestion:", error);
          let message = "Failed to delete suggestion."; // Pesan error default

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend
          } else {
            message = error.message || message; // Pesan error default
          }

          // Menampilkan pesan error
          store.dispatch("triggerSnackbar", { message, isSuccess: true });

          // Menutup dialog jika terjadi error
          this.isDialogOpen = false;
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    updatePagination(query) {
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.pagination.startDate = query.startDate || this.pagination.startDate;
      this.pagination.endDate = query.endDate || this.pagination.endDate;
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
    getToday() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Bulan mulai dari 0
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`; // Format ISO
    },
    onDateChange(param) {
      if (param === "start") {
        this.updateQuery("startDate", this.pagination.startDate); // Update startDate
      } else {
        this.updateQuery("endDate", this.pagination.endDate); // Update endDate
      }
    },
  },
  watch: {
    pagination: {
      handler: "fetchSuggestion",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
  },
  mounted() {
    store.commit("setTitle", "Suggestion");
    this.fetchSuggestionCategory();
    this.fetchSuggestion();
    this.updatePagination(this.$route.query);
  },
  computed: {
    user() {
      return store.getters["user/getUser"] || {}; // get Data User
    },
    title() {
      return store.state.title; // Mengakses title dari store
    },
    formattedBenefit: {
      get() {
        return new Intl.NumberFormat("id-ID").format(
          this.suggestionFormData.benefit
        );
      },
      set(value) {
        // Hapus titik saat input berubah, agar tetap bisa menyimpan angka asli
        this.suggestionFormData.benefit =
          parseInt(value.replace(/\./g, "")) || 0;
      },
    },
    formattedBenefitUpdate: {
      get() {
        return new Intl.NumberFormat("id-ID").format(
          this.suggestionFormDataUpdate.benefit
        );
      },
      set(value) {
        // Hapus titik saat input berubah, agar tetap bisa menyimpan angka asli
        this.suggestionFormDataUpdate.benefit =
          parseInt(value.replace(/\./g, "")) || 0;
      },
    },
    formattedBenefitDetail: {
      get() {
        return new Intl.NumberFormat("id-ID").format(
          this.suggestionDetail.benefit
        );
      },
      set(value) {
        // Hapus titik saat input berubah, agar tetap bisa menyimpan angka asli
        this.suggestionDetail.benefit = parseInt(value.replace(/\./g, "")) || 0;
      },
    },
  },
};
</script>

<style scoped>
.v-data-table td:nth-child(5),
td:nth-child(6),
td:nth-child(7),
td:nth-child(8) {
  text-align: center;
}
</style>
